import { installAuthMiddleware } from "@auth/refreshMiddleware";
import { BrowserGate } from "@scribenote/brian-design-system";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./index.css";
import { initRum } from "./observability/rum";

// Captures errors from render onward. Not earlier: the `./App` import chain
// evaluates before any statement here runs, and a config-load failure can
// never be captured either way — RUM's own credentials come from that same
// config, so a bad `env-config.js` deploy shows up in Datadog as zero
// sessions, not as an error. No-ops in environments where RUM is disabled.
initRum();

installAuthMiddleware();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserGate>
      <App />
    </BrowserGate>
  </StrictMode>,
);
